import { AppMenu } from "../../../objects/app-menu";

export interface RouteInfo extends AppMenu{
     
}
